export default __webpack_public_path__ + "static/20210505_KMW_by_Kruszewski_360-516ce1417898199a762816371e5fde75.jpg";